import React, { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Snackbar } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Fab from '@mui/material/Fab';
import CalculateIcon from '@mui/icons-material/Calculate';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import SearchIcon from '@mui/icons-material/Search';
import HomeIcon from '@mui/icons-material/Home';
import ComputerIcon from '@mui/icons-material/Computer';
import { useLocation } from 'react-router-dom';
import Chip from '@mui/material/Chip';

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="white">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
const FileView = ({display}) => {
  const [urlType, setUrlType] = useState('google')
  const [fileActive, setFileActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [minOpen, setMinOpen] = useState(false)
  const [showIframe, setShowIframe] = useState(false)
  const [errorTitle, setErrorTitle] = useState('')
  const [showWarning, setShowWarning] = useState(false)
  const [srcUrl, setSrcUrl] = useState('about:blank')
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isContent, setIsContent] = useState(false)
  const location = useLocation();
  const [height, setHeight] = useState(0);
  useEffect(()=>{
    setShowIframe(false)
    setHeight(0);
    setLoading(true)
    const iframeTimer = setTimeout(() => {
      setShowIframe(true)
    }, 240);
    return () => clearTimeout(iframeTimer)
  },[srcUrl])
  useEffect(() => {
      const handleURLChange = () => {
        if (window.location.pathname.startsWith('/editor/')) {
          setIsContent(true)
        }else {
          setIsContent(false)
        }
      };
      handleURLChange()
    }, [location]);
  function minimiseLoader() {
    setOpen(false)
    setMinOpen(true)
  }
  const onDrop = useCallback(async (acceptedFiles) => {
    setOpen(true);
    const file = acceptedFiles[0];
  
    // Check if there is an ongoing upload
    if (currentXhr) {
      currentXhr.abort();  // Abort the ongoing upload
    }
  
    const formData = new FormData();
    formData.append('file', file);
  
    const xhr = new XMLHttpRequest();
    setCurrentXhr(xhr);  // Store the current XMLHttpRequest
  
    try {
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const percentage = Math.round((event.loaded / event.total) * 100);
          setProgress(percentage);
        }
      });
  
      xhr.open('POST', 'https://server.donotes.app/save.php', true);
  
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          setCurrentXhr(null);  // Clear the stored XMLHttpRequest
          setOpen(false);
          setMinOpen(false);
          if (xhr.status === 200) {
            const result = JSON.parse(xhr.responseText);
            if (result.success) {
              if (result.fileUrl.endsWith('.pdf')) {
                
                setUrlType(result.fileUrl);
                setSrcUrl(`https://docs.google.com/gview?url=${result.fileUrl}&embedded=true`);
              } else {
                setUrlType(result.fileUrl);
                setSrcUrl(`https://docs.google.com/gview?url=${result.fileUrl}&embedded=true`);
              }
              setFileActive(true);
            } else {
              setErrorMessage(result.error);
              setErrorDialogOpen(true);
            }
          } else {
            console.error('File upload failed:', xhr.statusText);
            setErrorTitle('File upload failed');
            setErrorMessage(xhr.statusText);
            setErrorDialogOpen(true);
          }
        }
      };
  
      xhr.send(formData);
    } catch (error) {
      setCurrentXhr(null);  // Clear the stored XMLHttpRequest
      setOpen(false);
      console.error('Error during file upload:', error.message);
      setErrorTitle('Error during file upload');
      setErrorMessage(error.message);
      setErrorDialogOpen(true);
    }
  }, []);
  
  // Add a state to store the current XMLHttpRequest
  const [currentXhr, setCurrentXhr] = useState(null);
  

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
  };

  
  const handleIframeLoad = (event) => {
    setHeight('100%')
    setLoading(false);
    const iframe = event.target;
    try {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      // Checking if the document is loaded and has content
      if (iframeDocument && iframeDocument.body.innerHTML.trim().length === 0) {
        // Iframe loaded successfully but returns no content
        setShowWarning(true);
      }
    } catch (error) {
      // Error handling if accessing iframe content fails
      console.error('Error accessing iframe content:', error);
    }
  };
  return (
    <>
      {fileActive ? (
        <div style={{ display, width: '100%', height: '90%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 6 }}>
          {loading && <><CircularProgress /><br />Loading... </>}
          
      {showWarning && (
        <div className="warning">
          Warning: The content could not be loaded.<br />
          Would you like to try using the Microsoft File view?<br />
          <md-filled-tonal-button onClick={()=>{setSrcUrl(`https://view.officeapps.live.com/op/embed.aspx?src=${urlType}`)}}>
            Try MS File View
          </md-filled-tonal-button>
        </div>
      )}
         {
          showIframe &&
          <iframe
          src={srcUrl}
          onLoad={handleIframeLoad}
          width="95%"
          frameBorder="0"
          allowFullScreen
          style={{
            transition: '0.2s ease height',
            height, 
            borderRadius: 25, 
            marginRight: 5
          }}
        ></iframe>
         }
          <div style={{position: 'absolute', bottom: 10}}>
            
          <Fab color="primary" aria-label="Upload"  onClick={()=>{setFileActive(false); setSrcUrl('about:blank')}}>
            <HomeIcon />
          </Fab>
          </div>
        </div>
      ) : (
        <>
        <h2 style={{color: 'var(--md-sys-color-primary)', margin: 0}}>Apps       <Chip label="Alpha" variant="outlined" />
</h2>
        
        <div style={{
          display: 'flex',
          gap: 10,
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
        >
          {isContent ?
          <div style={{display, flex: '1'}}>
          <div {...getRootProps() } >
            
          <input {...getInputProps()} />
          <md-filled-tonal-button style={{width: 250}}>
            
  
            <CloudUploadIcon  slot="icon"  />
          File view
          </md-filled-tonal-button>
          </div>
          </div>:
          <md-filled-tonal-button disabled style={{width: 250}}>
              <CloudUploadIcon slot="icon" />
              File view
            </md-filled-tonal-button>}
        <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setSrcUrl('https://bitlearner.online/')
        }}
        style={{width: 250}}>
          <ComputerIcon slot="icon" />
          BitLearner.online
        </md-filled-tonal-button>
{/*         
        <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setSrcUrl('https://www.webcrawler.com')
        }}
        style={{width: 250}}>
          <SearchIcon slot="icon"/>
          WebCrawler Search
        </md-filled-tonal-button> */}
        
        
        <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setSrcUrl('https://anatomylearning.com/webgl2024v1/browser.php')
        }}
        style={{width: 250}}>
          <EmojiPeopleIcon slot="icon"/>
          Human anatomy
        </md-filled-tonal-button>
        
        
        <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setSrcUrl('https://excalidraw.com/')
        }}
        style={{width: 250}}>
          <EmojiPeopleIcon slot="icon"/>
          excalidraw
        </md-filled-tonal-button>
        <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setSrcUrl('https://server.donotes.app/calculator.html')
        }}
        style={{width: 250}}>
          <CalculateIcon slot="icon"/>
          Calculator
        </md-filled-tonal-button>

        <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setSrcUrl('https://donotes-server.com/drdonut')
        }}
        style={{width: 250}}>
<svg slot="icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/></svg>          
          Dr. Donut
        </md-filled-tonal-button>
        <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setSrcUrl('https://donotes-server.com:2712')
        }}
        style={{width: 250}}>
<svg slot="icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/></svg>          
          Convert notes to Anki
        </md-filled-tonal-button>
        
        {/* <md-filled-tonal-button onClick={()=>{
          setFileActive(true)
          setHeight(0)
          setSrcUrl('https://server.donotes.app/code.html');
          setTimeout(() => {
            setLoading(false)
            setHeight('100%');
          }, 250);
        }}
        style={{width: 250}}>

<svg slot="icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M320-240 80-480l240-240 57 57-184 184 183 183-56 56Zm320 0-57-57 184-184-183-183 56-56 240 240-240 240Z"/></svg>          HTML Editor
        </md-filled-tonal-button> */}
        </div>
        </>
      )}

      <Dialog open={errorDialogOpen} onClose={handleCloseErrorDialog}>
        <DialogTitle id="alert-dialog-title">
          {errorTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorDialogOpen(false)} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop
        open={open}
        onClick={minimiseLoader}
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 , display: 'flex', flexDirection: 'column'}}
      >
<CircularProgressWithLabel value={progress} /> 
      </Backdrop>
      <Snackbar
  open={minOpen}
  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} 
  message={`Loading... ${progress}%`}
/>
    </>
  );
};

export default FileView;
